import React, { useEffect, useState } from 'react';

import Icon from '@/components/ui/Icon';
import cn from '@/utils/cn';

const TRANSITION = 'tw-transition tw-duration-150 motion-reduce:tw-transition-none';

// The page-wide drop state: the file field's small dashed dropzone grown to the whole page. One
// piece of motion — the marching-ants frame (ptc-drop-march in _print_text_tools.scss) — plus a
// quick card entrance. Everything is pointer-events-none so the drop always reaches the window.
const IdmlDropOverlay = () => {
  const [shown, setShown] = useState(false);
  useEffect(() => setShown(true), []);

  return (
    <div
      aria-hidden="true"
      className={cn(
        'tw-pointer-events-none tw-fixed tw-inset-0 tw-z-50 tw-backdrop-blur-sm',
        'tw-bg-[color:color-mix(in_srgb,var(--spa-bg)_70%,transparent)]',
        TRANSITION,
        shown ? 'tw-opacity-100' : 'tw-opacity-0',
      )}
    >
      {/* Explicit size: an svg is a replaced element, so inset alone leaves it at 300x150. */}
      <svg className="tw-absolute tw-left-4 tw-top-4 tw-h-[calc(100%-2rem)] tw-w-[calc(100%-2rem)]">
        <rect className="ptc-drop-march" fill="none" rx="12" x="1" y="1" />
      </svg>
      <div className="tw-flex tw-h-full tw-items-center tw-justify-center">
        <div
          className={cn(
            'tw-flex tw-flex-col tw-items-center tw-gap-3 tw-rounded-lg tw-bg-spa-bg-secondary tw-px-10 tw-py-8',
            'tw-shadow-lg',
            TRANSITION,
            shown ? 'tw-scale-100 tw-opacity-100' : 'tw-scale-95 tw-opacity-0',
          )}
        >
          <span
            className="tw-flex tw-h-12 tw-w-12 tw-items-center tw-justify-center tw-rounded-full
              tw-bg-spa-accent-bg tw-text-spa-accent-text"
          >
            <Icon icon="Download" size={22} />
          </span>
          <span className="tw-text-xl tw-font-bold tw-text-spa-heading">
            Drop your print file
          </span>
          <span className="tw-text-sm tw-text-spa-secondary">
            The .idml loads into Print Tools, ready to analyze.
          </span>
        </div>
      </div>
    </div>
  );
};

export default IdmlDropOverlay;
